import React, { useEffect, useState } from "react";

import { Container, List, ListItem, ListItemText, ListSubheader, Paper, Stack } from '@mui/material';
import { RouteComponentProps } from "@reach/router";
import AppPage from "../../components/AppFrame/AppPage";
import { useAppDispatch, useAppSelector } from "../../hooks/redux";
import { NftAttribute, NftData } from "../../types/nft";
import { actions } from '../../services/nfts';
import NftCard from "../../components/NftCard/NftCard";
import { orderBy } from "lodash";


interface Props extends RouteComponentProps {
  tokenId?: string;
}

const NftPage: React.FC<Props> = ({ tokenId }) => {
  const nfts = useAppSelector(state => state.nfts.cache);

  const dispatch = useAppDispatch();

  const [ data, setData ] = useState<NftData>();
  const [ traits, setTraits ] = useState<NftAttribute[]>([]);

  useEffect(() => {
    if (!tokenId) {
      return;
    }
    const id = parseInt(tokenId);
    if (isNaN(id)) {
      return;
    }


    const nftData = nfts[ id ] ?? null;
    if (nftData) {
      setData(nftData);

      const list: NftAttribute[] = [];

      for (const trait in nftData.attributes) {
        list.push({
          trait_type: trait,
          value: nftData.attributes[ trait ]
        })
      }
      setTraits(orderBy(list, 'trait_type', 'asc'));
    }
    else {
      dispatch(actions.loadById(id));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ tokenId, nfts ]);


  const loading = !Boolean(data);


  return (
    <AppPage title={`HayApe #${tokenId}`} loading={loading}>
      {
        loading || !data ? null : (
          <Container maxWidth="md">
            <Stack direction="row" justifyContent="space-between" spacing={3}>
              <NftCard data={data} size={500} />
              <Paper sx={{flex: 1}}>
                <List
                  subheader={
                    <ListSubheader>
                      Traits
                    </ListSubheader>
                  }
                >
                  {
                    traits.map(item => (
                      <ListItem key={item.trait_type}>
                        <ListItemText primary={item.value} secondary={item.trait_type} />
                      </ListItem>
                    ))
                  }
                </List>
              </Paper>
            </Stack>
          </Container>
        )
      }
    </AppPage>
  );
};

export default NftPage;